<ng-template
	#productTmpl
	let-product="product"
	let-showPrices="showPrices"
	let-showPricesWithTax="showPricesWithTax"
	let-priceState="priceState"
	let-price="priceState.price"
	let-isPriceError="priceState.isError"
	let-isFetchingPrice="priceState.isFetching"
>
	<div
		class="product-wrapper product-list-links"
		fxLayout="row wrap"
		fxLayoutAlign="space-between center"
		fxLayoutGap="20px"
		[ngClass]="{ 'is-not-public': !product.is_published }"
	>
		<div class="product-info" fxFlex fxFlex.lt-md="100">
			<div class="img-wrapper">
				<div class="square-image-container">
					<div class="square-image-inner image-wrapper">
						<g-zoomable-image [images]="productImages.get(product.id)" key="fitIn_2000x2000">
							<img
								width="80"
								gFallbackProductImage
								class="square-image-centered"
								*ngIf="product?.images?.master"
								[src]="product?.images?.master?.fitIn_80x80"
								[alt]="product?.locale.product_name | getText"
								loading="lazy"
							/>
						</g-zoomable-image>
					</div>
				</div>
			</div>
			<a
				data-cy="product-link"
				fxLayoutAlign="start center"
				fxFlex
				[routerLink]="['/product', product.id, product.slug]"
				(click)="productClick(product.id)"
			>
				<div>
					<div class="product-name" title="{{ product?.locale.product_name | getText }}">
						{{ product?.locale.product_name | getText }}
					</div>
					<div class="stock-level" *ngIf="product?.properties?.storageInfo?.isStockLevelVisible">
						<div *ngIf="isInStock(product)">
							<span i18n class="stock-level-text">Available:</span>
							<span class="stock-level-value">{{ product.stock_level }}</span>
							<span class="stock-level-unit">{{ product.metadata.unit | getText }}</span>
						</div>
						<div *ngIf="!isInStock(product)">
							<span i18n class="stock-level-text out-of-stock">Not available at the moment.</span>
						</div>
					</div>
				</div>
			</a>
		</div>
		<span class="button-spacer" fxFlex.lt-md></span>
		<div *ngIf="isAValidStockOrPodProduct(product)">
			<div fxLayout fxLayoutAlign="end center" fxLayoutGap="10px">
				<g-product-option-selector
					[product]="product"
					[showHeader]="false"
					[truncateDropdownText]="true"
					[addPaddingToOptionItem]="true"
					[hidden]="!isInStock(product)"
					(selectedOptionsChanged)="selectedOptionsChanged($event, product)"
				>
				</g-product-option-selector>
				<span class="price" *ngIf="showPrices" [ngClass]="{ disabled: !isInStock(product) }">
					<span *ngIf="showPricesWithTax && price">
						{{ price.price_with_tax || 0 | number: '1.2-2' }} €
					</span>
					<span *ngIf="!showPricesWithTax && price">
						{{ price.price_without_tax || 0 | number: '1.2-2' }} €
					</span>
					<g-icon
						*ngIf="isFetchingPrice"
						class="price-spinner"
						[icon]="icons.faSpinner"
						pulse
						fixedWidth
					>
					</g-icon>
					<span *ngIf="!isFetchingPrice && (!price || isPriceError)" class="pricing-error" i18n
						>ERROR!</span
					>
				</span>
			</div>
		</div>
		<div class="button-container">
			<button
				type="button"
				class="btn btn-primary"
				[ngSwitch]="getButtonType(product)"
				[disabled]="isProductButtonDisabled(product, priceState, userPermissions$ | async)"
				(click)="onProductButtonClick(product)"
			>
				<span *ngSwitchCase="'cart'">
					<span *ngIf="isInStockForQuantity(product)" i18n>Add to Cart</span>
					<span *ngIf="!isInStockForQuantity(product)" i18n>Not available</span>
				</span>
				<span *ngSwitchCase="'form'">
					<span *ngIf="product?.metadata?.form_type === 'quote'">
						<span *ngIf="product?.metadata?.form_button_text | getText; let buttonText">
							{{ buttonText }}
						</span>
						<span *ngIf="!(product?.metadata?.form_button_text | getText)" i18n>Request quote</span>
					</span>
					<span *ngIf="product?.metadata?.form_type === 'order'">
						<span *ngIf="product?.metadata?.form_button_text | getText; let buttonText">
							{{ buttonText }}
						</span>
						<span *ngIf="!(product?.metadata?.form_button_text | getText)" i18n>Order</span>
					</span>
				</span>
				<span *ngSwitchDefault i18n>See Product Details</span>
			</button>
		</div>
	</div>
</ng-template>

<ng-container *ngIf="products$ | async; let products; else: noProducts">
	<div class="product-list" *ngIf="products.length">
		<div *ngIf="productPriceMap$ | async; let priceMap">
			<ng-container
				*ngFor="let product of products"
				[ngTemplateOutlet]="productTmpl"
				[ngTemplateOutletContext]="{
					product: product,
					priceState: priceMap.get(product.id) || {},
					showPrices: showPrices$ | async,
					showPricesWithTax: showPricesWithTax$ | async
				}"
			></ng-container>
		</div>
	</div>
</ng-container>
<ng-template #noProducts>
	<div i18n>No products.</div>
</ng-template>
